const tests = [
  {
    id: "1",
    topics_id: "1",
    code: "1.1",
    questions: "Ачааны автомашины бүх жинг хэрхэн тодорхойлох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "2",
    topics_id: "1",
    code: "1.2",
    questions:
      "Ачааны автомашины бодит жин нь бүх жинтэйгээ тэнцсэн үед ачсан ачааных нь жин ойролцоогоор ямар байх бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "3",
    topics_id: "1",
    code: "1.3",
    questions: "Ачаа ачих үед тээврийн хэрэгслийн бүх жин өөрчлөгдөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "4",
    topics_id: "1",
    code: "1.4",
    questions: "Тээврийн хэрэгслийн бодит жин аль тохиолдолд нэмэгдэх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "5",
    topics_id: "1",
    code: "1.5",
    questions:
      "Аль автомашины бүх жинд чиргүүлийнх нь бүх жинг оролцуулан тооцох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/0.jpg",
  },
  {
    id: "6",
    topics_id: "1",
    code: "1.6",
    questions:
      "Тээврийн хэрэгслийн бодит жинд чирүүлж яваа тээврийн хэрэгслийнх нь бодит жинг оролцуулан тооцох уу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "7",
    topics_id: "1",
    code: "1.7",
    questions: "Аль нь 'Автомашин' нэр томьёонд хамаарагдах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "8",
    topics_id: "1",
    code: "1.8",
    questions: "'Автобус' нэр томьёонд аль тээврийн хэрэгслийг хамааруулах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "9",
    topics_id: "1",
    code: "1.9",
    questions: "'Тээврийн хэргслээр зорчигч' гэж хэн бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "10",
    topics_id: "1",
    code: "1.10",
    questions:
      "Аль нь 'Хүүхдийг зохион байгуулалттай тээвэрлэх' үйл ажиллагаа вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "11",
    topics_id: "2",
    code: "2.1",
    questions:
      "'С' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн бүх жин нь 3.5 тонноос их ачааны автомашинаар чиргүүл чирч хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "12",
    topics_id: "2",
    code: "2.2",
    questions:
      "Зурагт үзүүлсэн автомашиныг ямар ангиллын эрхтэй хүн жолоодохыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/1.jpg",
  },
  {
    id: "13",
    topics_id: "2",
    code: "2.3",
    questions:
      "Хүн ба ачаа тээвэрлэхэд зориулагдаагүй, зурагт үзүүлсэн автомашин аль ангилалд хамаарагдах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/2.jpg",
  },
  {
    id: "14",
    topics_id: "2",
    code: "2.4",
    questions:
      "Бүх жин нь 7 тонн ачааны автомашин аль ангилалд хамаарагдах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "15",
    topics_id: "2",
    code: "2.5",
    questions:
      "'C' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн 'С1' дэд ангиллын тээврийн хэрэгсэл жолоодохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "16",
    topics_id: "2",
    code: "2.6",
    questions:
      "'C1' дэд ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн 'С' ангиллын тээврийн хэрэгсэл жолоодохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "17",
    topics_id: "2",
    code: "2.7",
    questions:
      "'C' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн 'СІЕ' дэд ангиллын тээврийн хэрэгсэл жолоодохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "18",
    topics_id: "2",
    code: "2.8",
    questions:
      "'C' ангилал болон 'С1Е' дэд ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн бүх жин нь 750 кг-аас илүү чиргүүлтэй 'С' ангиллын автомашин жолоодохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "19",
    topics_id: "2",
    code: "2.9",
    questions:
      "'D' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн угсраа автобус жолоодохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/3.jpg",
  },
  {
    id: "20",
    topics_id: "2",
    code: "2.10",
    questions:
      "'D1' дэд ангиллын тээврийн хэрэслийг жолоодох эрх авч болох насны доод хязгаар хэд бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "21",
    topics_id: "3",
    code: "3.1",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар аль чигт явахыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/4.jpg",
  },
  {
    id: "22",
    topics_id: "3",
    code: "3.2",
    questions:
      "Энэ тэмдэг байрласан замаар бүх жин нь 9 тонн ачааны автомашин явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/5.jpg",
  },
  {
    id: "23",
    topics_id: "3",
    code: "3.3",
    questions: "Энэ тэмдэг аль тээврийн хэрэгслийн хөдөлгөөнийг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/6.jpg",
  },
  {
    id: "24",
    topics_id: "3",
    code: "3.4",
    questions: "Аль автомашины хөдөлгөөнийг хориглох бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/7.jpg",
  },
  {
    id: "25",
    topics_id: "3",
    code: "3.5",
    questions: "Энэ тэмдэг аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/8.jpg",
  },
  {
    id: "26",
    topics_id: "3",
    code: "3.6",
    questions:
      "Зурагт үзүүлсэн ачааны автомашинд 8 тонн ачааачсан бол гүүрээр гарахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/9.jpg",
  },
  {
    id: "27",
    topics_id: "3",
    code: "3.7",
    questions:
      "Чирч яваа болон чирүүлж яваа автомашинуудын бодит жин нь тус бур 4 тонн бол гүүрээр гарахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/10.jpg",
  },
  {
    id: "28",
    topics_id: "3",
    code: "3.8",
    questions:
      "Ачааны автомашины бүх жин нь 9 тонн бол аль чигт явахыг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/11.jpg",
  },
  {
    id: "29",
    topics_id: "3",
    code: "3.9",
    questions: "Энэ тэмдаг аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/12.jpg",
  },
  {
    id: "30",
    topics_id: "3",
    code: "3.10",
    questions:
      "Аль тэмдгийн үйлчлэл тухайн тээврийн хэрэгслийн бодит жингээс хамаарах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/13.jpg",
  },
  {
    id: "31",
    topics_id: "3",
    code: "3.11",
    questions:
      "Бодит жин нь 9 тонн ачааны автомашины урд тэнхлэг дээрх ачаалал нь 3 тонн бол гүүрээр гарахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/14.jpg",
  },
  {
    id: "32",
    topics_id: "3",
    code: "3.12",
    questions:
      "Бодит жин нь 12 тонн ачааны автомашины урд тэнхлаг дээрх ачаалал нь 4 тонн бол гүүрээр гарахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/15.jpg",
  },
  {
    id: "33",
    topics_id: "3",
    code: "3.13",
    questions:
      "Зурагт үзүүлсэн автомашинаар гүүрний доогуур гарахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/16.jpg",
  },
  {
    id: "34",
    topics_id: "3",
    code: "3.14",
    questions:
      "Автомашины тэвшний өргөн 2.3м бол хонгил руу орохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/17.jpg",
  },
  {
    id: "35",
    topics_id: "3",
    code: "3.15",
    questions:
      "Энд бүх жин нь 3.5 тонноос их ачааны автомашинаар тракторыг гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/18.jpg",
  },
  {
    id: "36",
    topics_id: "3",
    code: "3.16",
    questions:
      "Энд бүх жин нь 3.5 тонноос их ачааны автомашинаар мотоциклыг гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/19.jpg",
  },
  {
    id: "37",
    topics_id: "3",
    code: "3.17",
    questions:
      "Энд бүх жин нь 3.5 тонноос их ачааны автомашинаар гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/20.jpg",
  },
  {
    id: "38",
    topics_id: "3",
    code: "3.18",
    questions:
      "Энэ тэмдгийн үйлчлэх хурээнд бүх жин нь 3.5 тонноос их ачааны автомашинаар аль тээврийн хэрэгслийг гүйцэж түрүүлэхийг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/21.jpg",
  },
  {
    id: "39",
    topics_id: "3",
    code: "3.19",
    questions:
      "Тэмдгийн үйлчлэх хүрээнд автобусаар гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/22.jpg",
  },
  {
    id: "40",
    topics_id: "3",
    code: "3.20",
    questions:
      "Замын энэ хэсэгт бүх жин нь 3.5 тонноос их ачааны автомашины гүйцэж түрүүлэх үйлдлийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/23.jpg",
  },
  {
    id: "41",
    topics_id: "3",
    code: "3.21",
    questions:
      "Чиглэлийн тээврийн хэрэгсэлд аль тэмдгийн үйлчлэл хамаарахгүй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/24.jpg",
  },
  {
    id: "42",
    topics_id: "3",
    code: "3.22",
    questions: "Аль тээврийн хэрэгслийн түр зогсолтыг зөвшөөрөх бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/25.jpg",
  },
  {
    id: "43",
    topics_id: "3",
    code: "3.23",
    questions:
      "Шар өнгийн тусгай гэрлэн дохио ажиллуулан замын засвар, арчлалтын ажил гүйцэтгэж яваа ачааны автомашины жолоочид аль тэмдгийн заалтыг зөрчихийг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/26.jpg",
  },
  {
    id: "44",
    topics_id: "3",
    code: "3.24",
    questions:
      "Ачааны автомашины хөдөлгөөн хориотой замын хэсээр явах зөвшөөрлийг зохих журмын дагуу авсан бүх жин нь 3.5 тонноос их ачааны автомашинд аль тэмдгийн үйлчлэл хамаарахгүй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/27.jpg",
  },
  {
    id: "45",
    topics_id: "3",
    code: "3.25",
    questions:
      "Зурагт үзүүлсэн бүх жин нь 3.5 тонноос их ачааны автомашины жолооч гүйцэх зорилгоор дунд эгнээнд орохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/28.jpg",
  },
  {
    id: "46",
    topics_id: "3",
    code: "3.26",
    questions: "Энэ тэмдэг нь:",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/29.jpg",
  },
  {
    id: "47",
    topics_id: "3",
    code: "3.27",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар аль чигт явахыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/30.jpg",
  },
  {
    id: "48",
    topics_id: "3",
    code: "3.28",
    questions:
      "Ачааны автомашин жолоодож яваа тохиолдолд зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/3-28.jpeg",
  },
  {
    id: "49",
    topics_id: "3",
    code: "3.29",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашин энэ эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/31.jpg",
  },
  {
    id: "50",
    topics_id: "3",
    code: "3.30",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашин энэ эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/32.jpg",
  },
  {
    id: "51",
    topics_id: "3",
    code: "3.31",
    questions: "Аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/33.jpg",
  },
  {
    id: "52",
    topics_id: "3",
    code: "3.32",
    questions:
      "Ачааны автомашин жолоодож яваа тохиолдолд энэ эгнээнээс барун гар тийш эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/34.jpg",
  },
  {
    id: "53",
    topics_id: "3",
    code: "3.33",
    questions: "Автобус баруун гар тийш эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/35.jpg",
  },
  {
    id: "54",
    topics_id: "3",
    code: "3.34",
    questions: "Зурагт үзүүлсэн автобус баруун гар тийш эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/36.jpg",
  },
  {
    id: "55",
    topics_id: "3",
    code: "3.35",
    questions: "Энэ тэмдэг чиглэлийн бус автобусны хөдөлгөөнийг хориглох уyy?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/37.jpg",
  },
  {
    id: "56",
    topics_id: "3",
    code: "3.36",
    questions:
      "Аль тэмдэг трактор, өөрөө явдаг машин механизм баруун гар тийш эргэхийг хориглох 6э?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/38.jpg",
  },
  {
    id: "57",
    topics_id: "3",
    code: "3.37",
    questions:
      "Аль тэмдэг чиргүүлтэй трактораар баруун гар тийш эргэхийг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/39.jpg",
  },
  {
    id: "58",
    topics_id: "3",
    code: "3.38",
    questions:
      "Аль тэмдэг ачааны автомашинаар механикжсан тээврийн хэрэгсэл чирч баруун гар тийш эргэхийг хориглох 6э?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/40.jpg",
  },
  {
    id: "59",
    topics_id: "3",
    code: "3.39",
    questions:
      "Аль тэмдэг тавигдсан уулзвараар бүх жин нь 3.5 тонноос их ачааны автомашин зөвхөн чигээрээ явах шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/41.jpg",
  },
  {
    id: "60",
    topics_id: "3",
    code: "3.40",
    questions:
      "Аль тэмдэгтэй зогсоолд бүх жин нь 3.5 тонноос их ачааны автомашин зогсохыг хориглох бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/42.jpg",
  },
  {
    id: "61",
    topics_id: "4",
    code: "4.1",
    questions:
      "Ачааны автомашины жолооч аль тохиолдолд ослын дохионы гэрлээ асааж явах шаардлагатай бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "62",
    topics_id: "4",
    code: "4.2",
    questions:
      "Аль тохиолдолд ослын зогсолтын тэмдгийг тухайн тээврийн хэрэгслийн ард байрлуулж хөдөлгөөнд оролцох шаардлагатай бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "63",
    topics_id: "4",
    code: "4.3",
    questions:
      "Өдрийн цагаар хүүхдийг зохион байгуулалттай тээвэрлэж явахдаа гэрэл асаах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "64",
    topics_id: "4",
    code: "4.4",
    questions:
      "Зорчигч буулгах, суулгахдаа аль автобусны жолооч ослын дохионы гэрлээ асаах шаардлагатай бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "65",
    topics_id: "4",
    code: "4.5",
    questions:
      "Зурагт үзүүлсэн автобусны жолооч хүүхэд буулгах, суулгахдаа заавал ослын дохионы гэрлээ асаах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/43.jpg",
  },
  {
    id: "66",
    topics_id: "4",
    code: "4.6",
    questions:
      "Зурагт үзүүлсэн автобусны ослын дохионы гэрэл ажиллахгүй болсон бол хүүхэд буулгах, суулгахдаа жолооч ямар арга хэмжээ авах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/44.jpg",
  },
  {
    id: "67",
    topics_id: "4",
    code: "4.7",
    questions:
      "Суурин газрын гаднах замд гүйцэж түрүүлж байгаагаа бусад жолоочид анхааруулахын тулд аль дохиог хэрэглэхийг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "68",
    topics_id: "4",
    code: "4.8",
    questions:
      "Аль тохиолдолд жолооч зайлшгүй зогсолт хийж байгаагаа бусдад анхааруулах зорилгоор дуут дохио өгөхийг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "69",
    topics_id: "4",
    code: "4.9",
    questions:
      "Өдрийн цагаар хөдөлгөөнд оролцохдоо аль тохиолдолд ойрын гэрлээ асаах шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "70",
    topics_id: "4",
    code: "4.10",
    questions:
      "Өдрийн цагт шар өнгийн тусай гэрлэн дохио ажиллуулсан тээврийн хэрэгслээр хамгаалуулж яваа ачааны автомашины жолооч ойрын гэрлээ асаах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "71",
    topics_id: "4",
    code: "4.11",
    questions:
      "Ачааны автомашины жолооч харанхуй үед чиргүүл чирч яваагаа бусдад хэрхэн анхааруулах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "72",
    topics_id: "4",
    code: "4.12",
    questions:
      "Чиргүүлтэй ачааны автомашины жолооч бүхээг дээрх улбар шар өнгийн гурван гэрлээ хэдийд асаах шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/45.jpg",
  },
  {
    id: "73",
    topics_id: "4",
    code: "4.13",
    questions:
      "«Чиргүүлтэй тээврийн хэрэгсэл» таних тэмдгийг аль тээврийн хэрэгсэлд байрлуулж хэрэглэх бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/46.jpg",
  },
  {
    id: "74",
    topics_id: "4",
    code: "4.14",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн ард «Урт тээврийн хэрэгсэл» таних тэмдгийг байрлуулах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/47.jpg",
  },
  {
    id: "75",
    topics_id: "4",
    code: "4.15",
    questions:
      "«Урт тээврийн хэрэгсэл» таних тэмдгийг аль тээврийн хэрэгсэлд хэрэглэх шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/48.jpg",
  },
  {
    id: "76",
    topics_id: "4",
    code: "4.16",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгсэлд аль таних тэмдгийг хэрэглэх шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/49.jpg",
  },
  {
    id: "77",
    topics_id: "4",
    code: "4.17",
    questions: "Энэ таних тэмдгийг аль тээврийн хэрэгсэлд хэрэглэх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/50.jpg",
  },
  {
    id: "78",
    topics_id: "4",
    code: "4.18",
    questions:
      "Суурин газрын гадна хүүхдийг зохион байгуулалттай тээвэрлэж яваа зурагт үзүүлсэн автобусны зөвшөөрөгдөх дээд хурд хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/51.jpg",
  },
  {
    id: "79",
    topics_id: "4",
    code: "4.19",
    questions:
      "«Аюултай ачаа» таних тэмдгийн цагаан дэвсгэртэй хэсэгт юуг тэмдэглэх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/52.jpg",
  },
  {
    id: "80",
    topics_id: "4",
    code: "4.20",
    questions:
      "Хүний амь нас, эрүүл мэнд, байгаль орчинд хор хөнөөл учруулж болзошгүй химийн бодисын хоосон сав, баглаа, боодлыг тээвэрлэхдээ «Аюултай ачаа» таних тэмдгийг хэрэглэх шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/53.jpg",
  },
  {
    id: "81",
    topics_id: "5",
    code: "5.1",
    questions:
      "Тээврийн хэрэгслийн оврын хэмжээнээс шалтгаалан зурагт үзүүлсэн эгнээнээс баруун гар тийш эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/54.jpg",
  },
  {
    id: "82",
    topics_id: "5",
    code: "5.2",
    questions:
      "Зорчих хэсгийн өргөн хүрэлцэхгүй тохиолдолд зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/55.jpg",
  },
  {
    id: "83",
    topics_id: "5",
    code: "5.3",
    questions:
      "Зорчих хэсгийн өргөн хүрэлцэхгүй тохиолдолд уулзвар дээр баруун гар талын эгнээнээс буцаж эргэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/56.jpg",
  },
  {
    id: "84",
    topics_id: "5",
    code: "5.4",
    questions:
      "Суурин газрын гаднах замд ачааны автомашин зурагт үзүүлсэн эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/57.jpg",
  },
  {
    id: "85",
    topics_id: "5",
    code: "5.5",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/58.jpg",
  },
  {
    id: "86",
    topics_id: "5",
    code: "5.6",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/59.jpg",
  },
  {
    id: "87",
    topics_id: "5",
    code: "5.7",
    questions:
      "Зурагт үзүүлсэн замын энэ эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/60.jpg",
  },
  {
    id: "88",
    topics_id: "5",
    code: "5.8",
    questions:
      "Хөдөлгөөний эрчим ихтэй үед ачааны автомашинаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/61.jpg",
  },
  {
    id: "89",
    topics_id: "5",
    code: "5.9",
    questions:
      "Зурагт үзүүлсэн бүх жин нь 3.5 тонноос их ачааны автомашины гүйцэх үйлдлийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/62.jpg",
  },
  {
    id: "90",
    topics_id: "5",
    code: "5.10",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар аль чигт явахын тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/63.jpg",
  },
  {
    id: "91",
    topics_id: "5",
    code: "5.11",
    questions:
      "Хөдөлгөөний эрчим ихтэй үед автобусаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/64.jpg",
  },
  {
    id: "92",
    topics_id: "5",
    code: "5.12",
    questions:
      "Автобусаар уулзварыг чигээрээ нэвтрэхийн тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/65.jpg",
  },
  {
    id: "93",
    topics_id: "5",
    code: "5.13",
    questions:
      "Сум заасан эгнээнд чиглэлийн тээврийн хэрэгслээр байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/66.jpg",
  },
  {
    id: "94",
    topics_id: "5",
    code: "5.14",
    questions:
      "Чиглэлийн бус автобусаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/67.jpg",
  },
  {
    id: "95",
    topics_id: "5",
    code: "5.15",
    questions:
      "Чиглэлийн тээврийн хэрэгсэл аль сумны дагуу зүүн гар тийш эргэхийг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/68.jpg",
  },
  {
    id: "96",
    topics_id: "5",
    code: "5.16",
    questions:
      "Автобус жолоодож яваа бол энэ эгнээнээс уулзварыг чигээрээ нэвтрэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/69.jpg",
  },
  {
    id: "97",
    topics_id: "5",
    code: "5.17",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар тууш замын энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/70.jpg",
  },
  {
    id: "98",
    topics_id: "5",
    code: "5.18",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашинаар тууш замын энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/71.jpg",
  },
  {
    id: "99",
    topics_id: "5",
    code: "5.19",
    questions:
      "Зурагт үзүүлсэн бүх жин нь 3.5 тонноос их ачааны автомашины гүйцэх үйлдлийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/72.jpg",
  },
  {
    id: "100",
    topics_id: "5",
    code: "5.20",
    questions: "Автобусаар тууш замын энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/73.jpg",
  },
  {
    id: "101",
    topics_id: "6",
    code: "6.1",
    questions:
      "Суурин газрын гадна ачааны автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "102",
    topics_id: "6",
    code: "6.2",
    questions:
      "Аль замд чиргүүлтэй ачааны автомашины зөвшөөрөгдөх дээд хурд цагт 60 км байх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "103",
    topics_id: "6",
    code: "6.3",
    questions: "Тууш замд ачааны автомашины зөвшөөрөгдөх дээд хурд хэд бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "104",
    topics_id: "6",
    code: "6.4",
    questions:
      "Тууш замд чиргүүлтэй ачааны автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "105",
    topics_id: "6",
    code: "6.5",
    questions:
      "Суурин газарт хүн тээвэрлэсэн троллейбусны зөвшөөрөгдөх дээд хурд хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "106",
    topics_id: "6",
    code: "6.6",
    questions:
      "Суурин газрын гадна хүн тээвэрлэсэн автобусны зөвшөөрөгдөх дээд хурд хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "107",
    topics_id: "6",
    code: "6.7",
    questions:
      "Аль замд хүн тэвэрлэсэн автобусны зөвшөөрөгдөх дээд хурд цагт 80 км байх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "108",
    topics_id: "6",
    code: "6.8",
    questions:
      "Тууш замд автобус цагт 100 км хүртэл хурдтай явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "109",
    topics_id: "6",
    code: "6.9",
    questions:
      "Аль тохиолдолд автобусны зөвшөөрөгдөх дээд хурд суурин газарт цагт 50 км байх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "110",
    topics_id: "6",
    code: "6.10",
    questions:
      "Хүүхдийг зохион байгуулалттай тээвэрлэх үеийн зөвшөөрөгдөх дээд хурд хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "111",
    topics_id: "7",
    code: "7.1",
    questions:
      "Энд бүх жин нь 3.5 тонноос их ачааны автомашин зогсохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/74.jpg",
  },
  {
    id: "112",
    topics_id: "7",
    code: "7.2",
    questions: "Энд ачааны автомашин зогсохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/75.jpg",
  },
  {
    id: "113",
    topics_id: "7",
    code: "7.3",
    questions: "Ачааны автомашиныг зурагт үзүүлснээр зогсоохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/76.jpg",
  },
  {
    id: "114",
    topics_id: "7",
    code: "7.4",
    questions: "Зурагт үзүүлснээр зогсохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/77.jpg",
  },
  {
    id: "115",
    topics_id: "7",
    code: "7.5",
    questions:
      "Зорчигч буулгах, суулгахдаа чиглэлийн тээврийн хэрэгслийн жолооч буудлын талбайн аль хэсэгт зогсох үүрэгтэй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/78.jpg",
  },
  {
    id: "116",
    topics_id: "7",
    code: "7.6",
    questions:
      "Зорчигч буулгах, суулгахдаа чиглэлийн тээврийн хэрэгслийн жолооч буудлын талбайн хашлаганд ямар зайтай шахаж зогсох үүрэгтэй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "117",
    topics_id: "7",
    code: "7.7",
    questions:
      "Бүх жин нь 3.5 тонноос их ачааны автомашиныг энд түр буюу удаан зогсоохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/79.jpg",
  },
  {
    id: "118",
    topics_id: "7",
    code: "7.8",
    questions:
      "Хороолол дотор зурагт үзүүлснээр ачаа буулгаж удаан хугацаагаар зогсохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/80.jpg",
  },
  {
    id: "119",
    topics_id: "7",
    code: "7.9",
    questions:
      "Энд ачааны автомашины хөдөлгүүрийг унтрааж удаан зогсоохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/81.jpg",
  },
  {
    id: "120",
    topics_id: "7",
    code: "7.10",
    questions: "Автобусыг энд удаан зогсоохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/82.jpg",
  },
  {
    id: "121",
    topics_id: "8",
    code: "8.1",
    questions:
      "Энэ тохиолдолд та хаана зогсож галт тэргийг өнгөрүүлэх үүрэгтэй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/83.jpg",
  },
  {
    id: "122",
    topics_id: "8",
    code: "8.2",
    questions:
      "Төмөр замын гармыг гэмтээж болзошгүй гинжит машин механизмыг гармаар хэрхэн гаргах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "123",
    topics_id: "8",
    code: "8.3",
    questions:
      "Цагт 8 км-ээс бага хурдтай явдаг машин механизмыг төмөр замын гармаар гаргахдаа тухайн гармыг хариуцсан суурь бүтэц эзэмшигчээс зөвшөөрөл авах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "124",
    topics_id: "8",
    code: "8.4",
    questions:
      "Суурь бүтэц эзэмшигчийн зөвшөөрөлгүйгээр төмөр замын гармаар нэвтрэх тээврийн хэрэгслийн ачаатай буюу ачаагүй өндрийн дээд хэмжээ хэд вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "125",
    topics_id: "8",
    code: "8.5",
    questions:
      "Зурагт үзүүлсэн автомашины жолооч төмөр замын гарам нэвтрэхдээ тухайн гармыг хариуцсан суурь бүтэц эзэмшигчээс зөвшөөрөл авах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/84.jpg",
  },
  {
    id: "126",
    topics_id: "8",
    code: "8.6",
    questions:
      "Тээврийн хэрэгслийн ачаатай өргөн нь 3 метр бол төмөр замын гармаар нэвтрэхдээ тухайн гармыг хариуцсан суурь бутэц эзэмшигчээс зөвшөөрөл авах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "127",
    topics_id: "8",
    code: "8.7",
    questions:
      "Хоёр чиргүүлтэй тээврийн хэрэгслээр төмөр замын гармыг нэвтрэхдээ тухайн гармыг хариуцсан суурь бүтэц эзэмшигчээс зөвшөөрөл авах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/85.jpg",
  },
  {
    id: "128",
    topics_id: "8",
    code: "8.8",
    questions:
      "Хүнд ачаатай тээврийн хэрэгслээр төмөр замын гармыг нэвтрэхдээ тухайн гармыг хариуцсан суурь бүтэц эзэмшигчээс зөвшөөрөл авах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "129",
    topics_id: "8",
    code: "8.9",
    questions:
      "Зурагт үзүүлсэн автомашины жолооч төмөр замын гарам нэвтрэхдээ тухайн гармыг хариуцсан суурь бүтэц эзэмшигчээс зөвшөөрөл авах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/86.jpg",
  },
  {
    id: "130",
    topics_id: "8",
    code: "8.10",
    questions:
      "Төмөр замын гарам дээр зайлшгүй зогсолт хийсэн тохиолдолд зорчигчдыг хэдийд буулгах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/87.jpg",
  },
  {
    id: "131",
    topics_id: "9",
    code: "9.1",
    questions:
      "Зурагт үзүүлснээр хөдөлгөөнд оролцох тохиолдолд чирүүлж яваа автомашины жолооч нь:",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/88.jpg",
  },
  {
    id: "132",
    topics_id: "9",
    code: "9.2",
    questions:
      "Механикжсан тээврийн хэрэгслийг ямар холбоогоор чирэх тохиолдолд чирэх, чирүүлэх тээврийн хэрэгслүүдийн хоорондын зай 3 метр байхыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "133",
    topics_id: "9",
    code: "9.3",
    questions:
      "Суурин газрын гадна механикжсан тээврийн хэрэгслийг чирэх үеийн зөвшөөрөгдөх дээд хурд хэд бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/89.jpg",
  },
  {
    id: "134",
    topics_id: "9",
    code: "9.4",
    questions:
      "Механикжсан тээврийн хэрэгслийг чирч яваа ачааны автомашины жолоочийн бүхээгт хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "135",
    topics_id: "9",
    code: "9.5",
    questions: "Чирүүлж яваа ачааны автомашинд хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "136",
    topics_id: "9",
    code: "9.6",
    questions:
      "Автобусыг автобусаар чирч яваа тохиолдолд хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/90.jpg",
  },
  {
    id: "137",
    topics_id: "9",
    code: "9.7",
    questions: "Зурагт үзүүлснээр чирэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/91.jpg",
  },
  {
    id: "138",
    topics_id: "9",
    code: "9.8",
    questions: "Зурагт үзүүлснээр чирэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/92.jpg",
  },
  {
    id: "139",
    topics_id: "9",
    code: "9.9",
    questions:
      "Жолооны механизм нь ажиллагаагүй болсон автомашиныг уулын замд чирэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "140",
    topics_id: "9",
    code: "9.10",
    questions: "Зурагт үзүүлснээр чирэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/93.jpg",
  },
  {
    id: "141",
    topics_id: "10",
    code: "10.1",
    questions: "Ачааны автомашины тэвшинд хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/94.jpg",
  },
  {
    id: "142",
    topics_id: "10",
    code: "10.2",
    questions:
      "Ачааны автомашины тэвшинд замын дагуух зорчигч тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/95.jpg",
  },
  {
    id: "143",
    topics_id: "10",
    code: "10.3",
    questions:
      "Ачааг дагалдаж яваа хүмүүсийг зурагт үзүүлснээр тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/96.jpg",
  },
  {
    id: "144",
    topics_id: "10",
    code: "10.4",
    questions: "Зурагт үзүүлснээр хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/97.jpg",
  },
  {
    id: "145",
    topics_id: "10",
    code: "10.5",
    questions:
      "Ачааг дагалдаж яваа хүмүүсийг зурагт үзүүлснээр тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/98.jpg",
  },
  {
    id: "146",
    topics_id: "10",
    code: "10.6",
    questions:
      "Зурагт үзүүлсэн автомашины краны бүхээгт хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/99.jpg",
  },
  {
    id: "147",
    topics_id: "10",
    code: "10.7",
    questions:
      "Ачааны автомашины тэвшин дотор зорчигчийн суудал засаж, шат, бүрхүүл гэх мэт хэрэгслээр нэмж тоноглон хүн тээвэрлэх зориулалтаар ашиглахыг зөвшөөрө үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "148",
    topics_id: "10",
    code: "10.8",
    questions:
      "Ачааны автомашины жолоочийн хажуугийн суудалд согтуу хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "149",
    topics_id: "10",
    code: "10.9",
    questions:
      "Ачааны автомашины жолоочийн бүхээгт 10 хүртэлх насны хүүхэд тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "150",
    topics_id: "10",
    code: "10.10",
    questions:
      "Ачааны автомашины жолоочийн бүхээгт 10 хүртэл насны хүүхдийг насанд хүрсэн хүн өвөр дээрээ авч явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "151",
    topics_id: "10",
    code: "10.11",
    questions:
      "Чиглэлийн тээврийн хэрэгслээр 10 хүртэлх насны хүүхдийг тээвэрлэхэд заавал зориулалтын нэмэгдэл суудал, хамгаалах хэрэгсэл ашиглах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "152",
    topics_id: "10",
    code: "10.12",
    questions:
      "Чиглэлийн тээврийн хэрэгсэлд 10 хүртэлх насны хүүхдийг насанд хүрсэн хүн өвөр дээрээ авч явахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "153",
    topics_id: "10",
    code: "10.13",
    questions:
      "Хотын доторх чиглэлийн тээврийн хэрэгслийн жолоочид юуг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "154",
    topics_id: "10",
    code: "10.14",
    questions:
      "Зорчигчийг зогсоогоор нь тээвэрлэхийг автобусны жолоочид зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "155",
    topics_id: "10",
    code: "10.15",
    questions:
      "Аялал, жуулчлалаар яваа автобусанд зорчигчийг зогсоогоор нь тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "156",
    topics_id: "10",
    code: "10.16",
    questions:
      "Хот хооронд зорчигч тээвэрлэж яваа автобусны жолоочид юуг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "157",
    topics_id: "10",
    code: "10.17",
    questions:
      "Аялалд явах автобусны зорчигчдын суудлыг заавал хамгаалах бүсээр тоноглосон байх шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "158",
    topics_id: "10",
    code: "10.18",
    questions:
      "Аль автобусны зорчигчдын суудлыг хамгаалах бүсээр тоноглосон байхыг шаардахгүй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "159",
    topics_id: "10",
    code: "10.19",
    questions:
      "Зурагт үзүүлсэн автобусанд суудлын тооноос нь олон хүүхэд тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/100.jpg",
  },
  {
    id: "160",
    topics_id: "10",
    code: "10.20",
    questions:
      "Автобусанд техникийн тодорхойлолтоор тогтоосон тооноос олон хүн тээвэрлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "161",
    topics_id: "11",
    code: "11.1",
    questions:
      "Ачааны автомашины жолооч ачаа тээвэрлэхдээ аль нөхцөлийг хангах үүрэгтэй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "162",
    topics_id: "11",
    code: "11.2",
    questions:
      "Тээврийн хэрэгсэл дээр ачсан ача аль нөхцөлийг хангасан байх шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "163",
    topics_id: "11",
    code: "11.3",
    questions:
      "Замд явах үед ачааны битүүмжлэл алдагдаж асгарч эхэлбэл хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/101.jpg",
  },
  {
    id: "164",
    topics_id: "11",
    code: "11.4",
    questions:
      "Ачааны автомашинаар хөдөлгөөнд оролцож явах үед аль тохиолдолд хөдөлгөөнөө үргэлжлүүлэхийг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "165",
    topics_id: "11",
    code: "11.5",
    questions:
      "Ачаа нь тээвэрлэлтийн үед их хэмжээний дуу чимээ гаргахаар ачигдсан бол хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "166",
    topics_id: "11",
    code: "11.6",
    questions:
      "Суурин газарт ачааг дуу чимээ гаргаж ачих, буулгахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "167",
    topics_id: "11",
    code: "11.7",
    questions:
      "Суурин газрын гадна 22 цагаас 06 цагийн хооронд ачаа ачиж, буулгахыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "168",
    topics_id: "11",
    code: "11.8",
    questions:
      "Тээврийн хэрэгслийн ачаатай буюу ачаагүй өндрийн хэдэн метрээс илуү бол хөдөлгөөнд оролцохдоо заавал тусгай журам, стандарт баримтлах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "169",
    topics_id: "11",
    code: "11.9",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо ямар арга хэмжээ авах шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/102.jpg",
  },
  {
    id: "170",
    topics_id: "11",
    code: "11.10",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо ямар арга хэмжээ авах шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/103.jpg",
  },
  {
    id: "171",
    topics_id: "11",
    code: "11.11",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо заавал тусгай журам, стандарт баримтлах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/104.jpg",
  },
  {
    id: "172",
    topics_id: "11",
    code: "11.12",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо заавал тусгай журам, стандарт баримтлах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/105.jpg",
  },
  {
    id: "173",
    topics_id: "11",
    code: "11.13",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо заавал тусгай журам, стандарт баримтлах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/106.jpg",
  },
  {
    id: "174",
    topics_id: "11",
    code: "11.14",
    questions:
      "Хоёроос олон чиргүүл чирч замын хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "175",
    topics_id: "11",
    code: "11.15",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслээр замын хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/107.jpg",
  },
  {
    id: "176",
    topics_id: "11",
    code: "11.16",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо ямар арга хэмжээ авах шаардлагатай бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/108.jpg",
  },
  {
    id: "177",
    topics_id: "11",
    code: "11.17",
    questions:
      "Зурагт үзүүлсэн тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо заавал тусгай журам, стандарт баримтлах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/109.jpg",
  },
  {
    id: "178",
    topics_id: "11",
    code: "11.18",
    questions:
      "Харанхуй үед овор ихтэй ачаа тээвэрлэж яваагаа бусад хөдөлгөөнд оролцогчдод хэрхэн анхааруулах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "179",
    topics_id: "11",
    code: "11.19",
    questions:
      "Аюултай ачаа тээвэрлэж хөдөлгөөнд оролцох жолооч ямар арга хэмжээ авах шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "180",
    topics_id: "11",
    code: "11.20",
    questions:
      "Аль тээврийн хэрэгслийн жолооч хөдөлгөөнд оролцохдоо тусгай журам, стандарт баримтлах шаардлагагүй вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "181",
    topics_id: "12",
    code: "12.1",
    questions:
      "Чиргүүлтэй автомашинаар хөдөлгөөнд оролцож явах үед чиргүүлийн холбоос эвдэрвэл хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "182",
    topics_id: "12",
    code: "12.2",
    questions:
      "Тоормосны механизм нь ажиллахгүй болсон чиргүүлийг чирч хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "183",
    topics_id: "12",
    code: "12.3",
    questions: "Ямар гэмтэлтэй тээврийн хэрэгслийг ашиглахыг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "184",
    topics_id: "12",
    code: "12.4",
    questions:
      "Аль тээврийн хэрэгслийн дугуйн хээний гүн нь газарт тулах хэсгээрээ 1 мм байхыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "185",
    topics_id: "12",
    code: "12.5",
    questions:
      "Аль тээврийн хэрэгслийн дугуйн хээний гүн нь газарт тулах хэсгээрээ 2 мм-ээ багагүй байх шаардлагатай вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "186",
    topics_id: "12",
    code: "12.6",
    questions:
      "Хүч дамжуулах ангийн ямар гэмтэлтэй автомашиныг ашиглахыг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "187",
    topics_id: "12",
    code: "12.7",
    questions:
      "Аль эд анги, хэрэгсэл нь бохирдсон буюу муудсан ачааны автомашиныг ашиглахыг зөвшөөрөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "188",
    topics_id: "12",
    code: "12.8",
    questions: "Ямар гэмтэлтэй автобусыг ашиглахыг хориглох вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "189",
    topics_id: "12",
    code: "12.9",
    questions:
      "Ачааны автомашины жолооч заавал ослын зогсолтын тэмдэг авч явах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "190",
    topics_id: "12",
    code: "12.10",
    questions: "Автобусны жолооч заавал ивүүр авч явах шаардлагатай юу?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "191",
    topics_id: "13",
    code: "13.1",
    questions:
      "Цагт ойролцоогоор 60 км хурдтай яваа тээврийн хэрэгсэл 1 секундэд ямар зайг туулах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "192",
    topics_id: "13",
    code: "13.2",
    questions:
      "Ядаргаа нь жолоочийн анхаарал болон самбаачлах хугацаанд хэрхэн нөлөөлөх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "193",
    topics_id: "13",
    code: "13.3",
    questions: "Автомашины бүрэн зогсолтын зам аль үзүүлэлтээс хамаарах бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "194",
    topics_id: "13",
    code: "13.4",
    questions: "Зам, дугуйн барьцалтын хүч аль үзүүлэлтээс хамаарах бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "195",
    topics_id: "13",
    code: "13.5",
    questions: "Аль тохиолдолд зам, дугуйн барьцалтын хүч багасах вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "196",
    topics_id: "13",
    code: "13.6",
    questions: "Хүндийн төвийн аль байрлалд автомашин илүү тогтвортой байх бэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "197",
    topics_id: "13",
    code: "13.7",
    questions: "Автомашины хүндийн төв аль тохиолдолд дээшээ шилжих вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "198",
    topics_id: "13",
    code: "13.8",
    questions:
      "Ямар учраас дундуур устай автоцистерн дүүрэн устай байх үеийнхээсээ харьцангуй тогтвор муутай байдаг 6э?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/110.jpg",
  },
  {
    id: "199",
    topics_id: "13",
    code: "13.9",
    questions:
      "Эргэх үйлдэл хийх үед автомашины төвөөс зугтах хүч аль тохиолдолд ихсэх вэ?",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "",
  },
  {
    id: "200",
    topics_id: "13",
    code: "13.10",
    questions: "Чиргүүлтэй автомашин эргэх үед:",
    tdate: "2026-03-26 12:00:00",
    desc: "",
    images: "/images/additional/111.jpg",
  },
];

export default tests;
